const Crop = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "image": "Image",
    "pdfs": "PDF",
    "existing_pdfs": "Existing PDF",
    "search": "Search",

    // PAGE HEADER
    "crop": "Crop",

    // ERROR
    "error_name": "Enter Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",
    "error_image": "Choose Image",
    "error_pdfs_max": "Maximum 10 PDF files allowed",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": 'DESCRIPTION',
    "table_status": "STATUS",

}

export default Crop;